var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNoSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2032 20.9554C40.7557 19.8829 44.6757 19.1816 49.0041 19.1816C68.5632 19.1816 84.4066 35.1866 84.4066 54.9454C84.4066 74.7041 68.5632 90.7091 49.0041 90.7091C29.4449 90.7091 13.6016 74.7041 13.6016 54.9454C13.6016 47.6029 15.8066 40.7554 19.5632 35.0629",
    stroke: "#E0E5ED",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1406 21.945L39.8581 8.25",
    stroke: "#E0E5ED",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1406 21.9434L41.8181 32.0909",
    stroke: "#E0E5ED",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55.0007C74 68.3407 62.8 79.1673 49 79.1673C35.2 79.1673 24 68.3407 24 55.0007C24 41.6607 35.2 30.834 49 30.834C62.8 30.834 74 41.6607 74 55.0007Z",
    fill: "#E0E5ED",
    stroke: "#E0E5ED",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2859 62.6862L50.5359 58.2154C49.1859 57.4421 48.0859 55.5812 48.0859 54.0587V44.1504",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoSession);
export default __webpack_public_path__ + "static/media/ic_no_session.32787c1d5ddc7ed0b485df4bf2344224.svg";
export { ForwardRef as ReactComponent };